<template>
  <div id="head">
    <div>
      <el-header height="48px">
        <div class="clearFix headWrap" style="height: 100%;">
          <div style="height: 100%;display: flex;align-items: center;float: left;width: calc(100% - 85px);">
            <div class="logo-box">
              <div class="p-n02v3__shape">
                <a href="javascript:;" class="p-n02v3__shapelink ">
                  <div class="p-n02v3__brand">
                    <div class="p-n02v3__shapegradient" title="会员商城" @click="toIndex">
                      <div class="p-body-copy-03">会员商城</div>
                    </div>
                    <div class="p-n02v3__philips" @click="toPhilips">
                      <img src="../assets/images/logo-text.svg" srcset="../assets/images/logo-text.svg 1x" width="85" alt="Philips">
                    </div>
                    <div class="p-n02v3__shapetop" aria-hidden="true">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMidYMid meet" x="0" y="0" width="98" height="45" viewBox="0, 0, 196, 90">
                        <path d="M154.001,90.001 C176.012,90.022 195.966,82.011 196.001,60 L196.001,0.001 L-0.001,0.001 L-0.001,90.001 L154.001,90.001 z" fill="#fff" id="Shape_top"></path>
                      </svg>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <ul class="one-category" v-if="!showSearch">
              <li>
                <span @click="toIndex">首页</span>
              </li>
              <li :class="oneCategoryId == one.id ? 'active' : ''" v-for="(one, index) in oneCategory" :key="index">
                <span @click="getTwoCategory(one.id, one.name)">{{one.name}}</span>
              </li>
            </ul>
            <div class="search-wrap" v-if="showSearch">
              <!-- 搜索框 -->
              <div class="search-box">
                <div class="search-form">
                  <div class="left-icon" @click="getSearch">
                    <span class="iconfont icon-search1"></span>
                  </div>
                  <input v-on:keyup.enter="getSearch" autofocus placeholder="您在寻找什么?" v-model="keyword" />
                </div>
                <div class="right-icon" @click="showSearch = false">
                  <span class="iconfont icon-iconfontclose"></span>
                </div>
              </div>
              <!-- 搜索提示 -->
              <div class="auto-tip" v-show="keyword && restaurants.length != 0">
                <div style="position: relative;">
                  <div v-for="(item, index) in restaurants" class="name" @click="handleSelect(item)" :key="index">
                    {{ item }}
                  </div>
                </div>
                <div class="popper-arrow"></div>
              </div>
            </div>
          </div>
          <div class="user-info">
            <i class="iconfont icon-search1" v-if="!showSearch" @click="showSearch = !showSearch"></i>
            <span class="user-icon">
              <el-popover
                popper-class="head-popover"
                placement="bottom"
                trigger="hover">
                <span slot="reference">
                  <i v-if="!isLogin" class="iconfont icon-gerenzhongxin"></i>
                  <i v-if="isLogin" class="iconfont icon-gerenzhongxinyonghu01"></i>
                </span>
                <ul class="personal" v-if="isLogin">
                  <li>
                    <router-link @click.native="toUser('order-list')" :to="`/order-list`">我的订单</router-link>
                  </li>
                  <li>
                    <router-link @click.native="toUser('center')" :to="`/center`">个人中心</router-link>
                  </li>
                  <li @click="logout">
                    <span>安全退出</span>
                  </li>
                </ul>
                <ul class="personal" v-if="!isLogin">
                  <li @click="toLogin">
                    <span>登录</span>
                  </li>
                  <li>
                    <router-link @click.native="toUser('register')" :to="`/register`">注册</router-link>
                  </li>
                </ul>
              </el-popover>
            </span>
            <span class="user-cart" @click="toCart">
              <i class="iconfont icon-cart4e"></i>
              <em class="shopping-amount" v-if="isLogin && $store.getters.cartNum">{{$store.getters.cartNum}}</em>
            </span>
          </div>
        </div>
      </el-header>
      <div class="two-category" v-show="twoCategory.length && isShowTwoCategory">
        <ul>
          <li v-for="(two, index) in twoCategory" :key="index">
            <span @click="toList(two)">{{two.name}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request'
import { mapActions } from 'vuex'
// import totalVm from '@/assets/js/event'
export default {
  name: 'Head',
  data () {
    return {
      showSearch: false,
      oneCategory: [],
      twoCategory: [],
      oneCategoryId: '',
      oneCategoryName: '',
      isShowTwoCategory: false, // 是否显示二级菜单
      isLogin: false,
      keyword: '',
      restaurants: []
    }
  },
  watch: {
    showSearch (val) {
      if (val == false) {
        this.keyword = ''
      }
    },
    keyword (val) {
      if (!val) {
        this.restaurants = []
      } else {
        this.querySearch()
      }
    }
  },
  created () {
    this.isLogin = this.$store.getters.status
    this.initOne()
    if (this.isLogin) {
      this.loadCartNum()
    }
  },
  methods: {
    ...mapActions([
      'loadCartNum'
    ]),
    toUser(type) {
      philips.analytics.trackNavNena({
        navdest: type,
        navid: "header",
        navtype: "nena"
      })
    },
    toCart () {
      if (this.isLogin) {
        if (this.$route.name != 'cart') {
          philips.analytics.trackNavNena({
            navdest: 'cart',
            navid: "header",
            navtype: "nena"
          })

          this.$router.push('/cart')
        }
      } else {
        let href = '/cart'
        this.$router.replace(`/login?redirectUrl=${href}`)
      }
    },
    toIndex () {
      if (this.$route.name != 'index') {
        this.$router.push('/index')
      }
    },
    toPhilips () {
      window.open('https://www.philips.com.cn/', '_blank')
    },
    toLogin () {
      if (this.$route.path != '/login') {
        let href = location.href.split('/#')[1]
        this.$router.push(`/login?redirectUrl=${href}`)
      }
    },
    async logout () {
      try {
        await request(`/gateway/users/users/member/logout`, 'post', {})
        this.$store.commit('SET_INFO', {})
        this.$store.commit('SET_STATUS', false)
        localStorage.clear()
        this.$router.replace(`/login`)
      } catch (e) {
      }
    },
    toList (item) {
      philips.analytics.trackNavNena({
        navdest: item.name,
        navid: "header",
        navtype: "nena"
      });

      this.isShowTwoCategory = false
      let id = this.oneCategoryId
      this.oneCategoryId = ''
      this.oneCategoryName = ''
      this.$router.push(`/product-list?oneId=${id}&twoId=${item.id}`)
      // window.open(`/#/product-list?oneId=${id}&twoId=${item.id}`, '_blank')
    },
    async querySearch () {
      if (this.keyword) {
        let res = await request('/gateway/product/product/product/searchTips', 'post', {
          name: this.keyword,
          pageSize: 1000,
          pageNum: 1
        })
        let result = res.data.list ? res.data.list : []
        if (result.length > 10) {
          this.restaurants = result.splice(0, 10)
        } else {
          this.restaurants = result
        }
      }
    },
    handleSelect (val) {
      this.keyword = val
      this.restaurants = []
      this.getSearch()
    },
    getSearch () {
      philips.analytics.trackConversion ({ 
        name:"search",  
        results: "true", 
        keywords: this.keyword
      })
      // 数据埋点开始 2021.05.28
      try {
        let usersDataSave = {
          activeId: null, // 如果IsActiveAct为1，则该字段不可为空
          advert: null, // 广告
          category: null, // 分类
          content: `搜索 - ${this.keyword}`, // 内容
          ctn: this.null, // 商品数据
          isActiveAct: 0, // 是否活动互动（0-否 1-是）
          type: 44 // 1 注册;3 购买;25 页面点击;37 加购物车;39 转发分享;40 种草;41 授权使用微信手机;42 绑定手机号;44 搜索;
        };
        this.$userActionSave(usersDataSave);
      } catch (e) {}
      // 数据埋点结束
      this.showSearch = false
      this.$router.push(`/product-list?keyword=${this.keyword}`)
      // window.open(`/#/product-list?keyword=${this.keyword}`, '_blank')
    },
    async initOne () {
      try {
        let res = await request('/gateway/product/product/product-category/list/tab/0', 'get')
        this.oneCategory = res.data || []
      } catch (e) {
      }
    },
    async getTwoCategory (id, name) {
      philips.analytics.trackNavNena({
        navdest: name,
        navid: "header",
        navtype: "nena"
      });

      if (this.oneCategoryId && this.oneCategoryId === id) {
        this.isShowTwoCategory = false
        this.oneCategoryId = ''
        this.oneCategoryName = ''
      } else {
        this.oneCategoryId = id
        this.oneCategoryName = name
        try {
          let res = await request(`/gateway/product/product/product-category/list/tab/${id}`, 'get')
          this.twoCategory = res.data || []
          if (this.twoCategory.length) {
            this.isShowTwoCategory = true
          } else {
            this.$store.commit('SET_BANNER', '')
            this.$router.push(`/product-list?oneId=${id}`)
            // window.open(`/#/product-list?oneId=${id}`, '_blank')
          }
        } catch (e) {
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/css/mixin';
  #head {
    position: relative;
    height: 48px;
    >div {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 3;
      left: 0;
    }
    .el-header {
      background: $blue;
      padding: 0;
      border-bottom: 1px solid #176498;
    }
    .headWrap {
      width: 80vw;
      margin: 0 auto;
      .one-category {
        width: calc(100% - 96px);
        margin-left: 0.5vw;
        flex: none;
        display: flex;
        flex-wrap: wrap;
        li {
          // height: 48px;
          // line-height: 48px;
          display: inline;
          // padding-left: 10px;
          // padding-right: 10px;
          padding: 0 0.6vw;
          font-size: 13px;
          span {
            color: #daf1f7;
            cursor: pointer;
            font-weight: 300;
          }
          span:hover {
            color: #fff;
          }
        }
        li.active {
          span {
            color: #fff;
            // font-weight: 400;
          }
        }
      }
      .search-wrap {
        margin-left: 50px;
        width: calc(100% - 50px);
        position: relative;
        .auto-tip {
          position: absolute;
          top: 55px;
          left: 0;
          width: 100%;
          padding: 5px 0;
          max-height: 60vw;
          background: #fff;
          color: #606266;
          z-index: 9;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          border-radius: 4px;
          border: 1px solid #e4e7ed;
          .name {
            line-height: 2.5;
            padding: 0 20px;
            cursor: pointer;
          }
          .name:hover {
            background: #efefef;
          }
        }
      }
      .search-box {
        height: 48px;
        background-color: #176498;
        display: flex;
        align-items: center;
        width: 100%;
        .search-form {
          position: relative;
          padding-left: 50px;
          width: calc(100% - 100px);
          .left-icon {
            position: absolute;
            left: 15px;
            top: 50%;
            color: #fff;
            transform: translateY(-50%);
            span {
              font-size: 20px;
              cursor: pointer;
            }
          }
          input {
            height: 48px;
            border: none;
            outline: none;
            color: #fff;
            font-size: 16px;
            background-color: #176498;
            width: 100%;
          }
        }
        .right-icon {
          width: 50px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          color: #fff;
          span {
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
    }
    .logo-box {
      position: relative;
      height: 100%;
      width: 95px;
      display: inline-block;
      flex: none;
      cursor: pointer;
    }
    .two-category {
      background: #176498;
      position: absolute;
      left: 0;
      top: 48px;
      right: 0;
      z-index: 4;
      ul {
        width: 80vw;
        margin: 0 auto;
        li {
          height: 48px;
          line-height: 48px;
          display: inline;
          padding-right: 20px;
          font-size: 13px;
          span {
            color: #daf1f7;
            cursor: pointer;
            font-weight: 300;
          }
          span:hover {
            color: #fff;
          }
        }
      }
    }
    .user-info {
      position: relative;
      float: right;
      color: #fff;
      display: flex;
      align-items: center;
      line-height: 44px;
      i {
        font-size: 22px;
        cursor: pointer;
      }
      .user-cart {
        position: relative;
        cursor: pointer;
        .shopping-amount {
          position: absolute;
          top: 8px;
          right: -6px;
          padding: 1px;
          font-size: 12px;
          line-height: 14px;
          color: #fff;
          background-color: #f10215;
          -moz-border-radius: 50% 50% 50% 0;
          border-radius: 50% 50% 50% 0;
          min-width: 14px;
          text-align: center;
        }
      }
      .icon-cart4e {
        font-size: 20px;
      }
      .user-icon {
        margin: 1px 10px 0;
      }
    }
  }
  body {
    .head-popover {
      background: $blue;
      color: #fff;
      border: 1px solid $blue;
      border-radius: 0;
      top: 48px !important;
      padding: 0;
      .popper__arrow {
        border-width: 10px;
      }
      .personal {
        width: 180px;
        li {
          padding: 11px;
          border-bottom: 1px solid #5B9BD5;
          cursor: pointer;
          text-align: center;
          font-size: 16px;
          a {
            color: #fff;
          }
        }
        li:last-child {
          border-bottom: none;
        }
      }
    }
    .head-popover[x-placement^=bottom] .popper__arrow {
      top: -10px;
      border-bottom-color: $blue;
    }
    .head-popover[x-placement^=bottom] .popper__arrow::after {
      border-bottom-color: $blue;
    }
  }
  @media only screen and (max-width: 1080px) {
    #head {
      .headWrap {
        width: 92vw;
        .one-category {
          li {
            padding: 0 4px;
          }
        }
      }
      .two-category {
        ul {
          width: 92vw;
        }
      }
    }
    body {
      .el-popover {
        .personal {
          li {
            font-size: 14px;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1280px) and (min-width: 1081px) {
    #head {
      .headWrap {
        .one-category {
          li {
            padding: 0 4px;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1500px) {
    #head {
      .headWrap {
        width: 70vw;
      }
      .two-category {
        ul {
          width: 70vw;
        }
      }
    }
  }
  @media only screen and (max-width: 1000px) and (min-width: 768px) {
    #head {
      .headWrap {
        .one-category {
          li {
            padding: 0 5px;
          }
        }
      }
    }
  }
  .search-form {
    input::-webkit-input-placeholder {
      /* placeholder颜色  */
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Head.vue